export default __webpack_public_path__ + "static/media/medicationTip.8899eb5b.png";